<template>
  <v-app>
    <SuperiorMenu v-if="this.$route.path != '/login' && !this.$route.path.includes('/linea') "> </SuperiorMenu>

    <v-main
      v-if="isMounted"
      :class="has_bottom_drawer ? '' : 'pb-0'"
    >
      <router-view />

      <v-overlay :value="isInactive" opacity="0.7" class="overlay">
        <v-card class="overlay-content">
          <v-icon large color="white">mdi-sleep</v-icon>
          <p class="text-white mt-3">Estás inactivo</p>
        </v-card>
      </v-overlay>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import SuperiorMenu from "@/components/layout/SuperiorMenu.vue";

export default {
  name: "App",

  components: {
    SuperiorMenu,
  },

  data: () => ({
    isMounted: false,
    isInactive: false,
    inactivityTimer: null,
    sessionTimer: null,
  }),

  computed: {
    ...mapState(["selectedItem", "editing"]),

    isLocal(){
      return !window.location.hostname.includes("quesos.koiote.es") && this.$route.path == "/";
    },

    has_bottom_drawer() {
      return this.editing && this.actualPage()?.global_item_list?.length > 0;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions(["retrieveToken", "getData"]),

    startInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.isInactive = true; // Mostrar pantalla gris después de 3 min
        console.log("Usuario INACTIVO");
      }, 10 * 60 * 1000); // 3 minutos
    },

    // Latido: mantiene viva la sesión aunque la pantalla no haga otras peticiones
    // (quiosco con datos por MQTT). Si toca, el backend devuelve un token renovado.
    keepSessionAlive() {
      if (this.$store.state.token) this.getData({ path: "auth/session" }).catch(() => {});
    },

    handleUserActivity() {
      if (this.isInactive) {
        console.log("Usuario ACTIVO de nuevo");
        window.location.reload();
      }

      this.isInactive = false; // Ocultar pantalla gris
      this.startInactivityTimer();
    },
  },

  async mounted() {
    await this.retrieveToken();

    this.keepSessionAlive();
    this.sessionTimer = setInterval(this.keepSessionAlive, 60 * 60 * 1000); // cada hora

    
    //Si estamos en local, añadimos los eventos para la inactividad
    if (this.isLocal) {
      this.startInactivityTimer();
      
      window.addEventListener("click", this.handleUserActivity);
      window.addEventListener("mousemove", this.handleUserActivity);
    }
    this.isMounted = true;
  },

  beforeUnmount() {
    window.removeEventListener("mousemove", this.handleUserActivity);
    window.removeEventListener("keydown", this.handleUserActivity);
    window.removeEventListener("click", this.handleUserActivity);
    clearTimeout(this.inactivityTimer);
    clearInterval(this.sessionTimer);
  },
};
</script>

<style scoped>
.logo-drawer {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
  justify-content: center;
}

.drawer-list-item {
  margin-bottom: 5px;
}
.overlay-content {
  background: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}
</style>
